import Dialog from 'src/helpers/dialog'

export default function (payload) {
  const title = payload.title
  const body = payload.body

  Dialog({
    title,
    message: body,
    persistent: true
  })
}
